export default __webpack_public_path__ + "static/media/pl.js.db074602.map";